module.exports = __webpack_public_path__ + "img/trash@1.5x.7499ec9c.svg";